import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchItineraryOptionsConfig } from '../../../../store/itineraryOptions/itineraryOptions.actions'
import { USER_SCREENS } from '../../../../store/ui/ui.constants'
import { setUiUserScreen } from '../../../../store/ui/uiSlice'
import { withEmptyFallbackErrorBoundary } from '../../../error/EmptyFallbackErrorBoundary'
import RectangleActionButton, { COLOR_GREEN, SIZE_BIG } from '../../../genericComponents/buttons/RectangleActionButton'
import ItineraryOptions from '../../../itineraryOptions/ItineraryOptions'
import { useAction } from '../../../utils/react-redux'
import useEventCallback from '../../../utils/useEventCallback'
import UserScreenContent from '../../shared/UserScreenContent'
import UserScreenHeader from '../../shared/UserScreenHeader'
import s from './UserItineraryOptions.less'

const UserItineraryOptions = () => {
  const dispatch = useDispatch()
  const execFetchItineraryOptionsConfig = useAction(fetchItineraryOptionsConfig)

  useEffect(() => {
    execFetchItineraryOptionsConfig()
  }, [])

  const onValidate = useEventCallback(() => dispatch(setUiUserScreen({ name: USER_SCREENS.default })))

  return (
    <>
      <UserScreenHeader>{'Mes options de déplacement'}</UserScreenHeader>
      <UserScreenContent>
        <div className={s.optionsWrapper}>
          <ItineraryOptions />
          <div className={s.ValidateArea}>
            <RectangleActionButton
              onClick={onValidate}
              size={SIZE_BIG}
              color={COLOR_GREEN}
              className={s.ValidateButton}
              label="itinerary.options.validate"
            />
          </div>
        </div>
      </UserScreenContent>
    </>
  )
}

export default withEmptyFallbackErrorBoundary(UserItineraryOptions)
